import React, { useState } from 'react';
import ContactModal from './ContactModal';

const Hero = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <section 
      className="text-black body-font min-h-[60vh] md:h-screen relative overflow-hidden"
    >
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: 'url("/images/img-7.jpeg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          filter: 'none',
          transform: 'scale(1.01)'
        }}
      ></div>
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="container mx-auto flex px-5 py-12 md:py-24 md:flex-row flex-col items-center relative z-10 h-full">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left md:mb-16 md:mb-0 items-center gap-6 text-center max-sm:mt-16">
          <h1 className="title-font sm:text-3xl text-xl mb-4 font-semibold text-white">
            Professional Christmas Light Installation in Barrie, Collingwood & Orillia. 
          </h1>
          <p className='text-xl font-600 font-bold text-white mb-4'>
            Elegant Christmas Lighting for Memorable Holidays. Christmas Light Installation Barrie.
          </p>
          
          <div className="flex justify-center">
            <button 
              onClick={() => setShowForm(true)}
              className="btn-primary text-white border-0 py-3 px-8 focus:outline-none rounded-lg text-lg font-semibold"
            >
              Get Your Free Quote Today
            </button>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
        </div>
      </div>

      <ContactModal isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Hero;